import BaseApi from './BaseApi'
import axios from '@/plugins/private-api-axios';

export default class VehicleApi extends BaseApi {
    async getGroupedVehicles () {
        return this.get('/api/v1.0/vehicles/grouped');
    }
    async getVehicles (params = {
        skip: null,
        take: null,
        registrationNumber: null,
        fleetId: null,
    }) {
        const request = new URLSearchParams()

        if (params.skip) {
            request.append('Skip', params.skip)
        }

        if (params.take) {
            request.append('Take', params.take)
        }

        if (params.registrationNumber) {
            request.append('RegistrationNumber', `%${params.registrationNumber}%`)
        }
        if (params.fleetId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get('/api/v1.0/vehicles', request)
    }
    async getVehicle (id) {
        return this.get(`/api/v1.0/vehicles/${id}`)
    }
    async deleteVehicle (id) {
        return this.delete(`/api/v1.0/vehicles/${id}`)
    }
    async createVehicle (
        fleetId,
        registrationNumber,
        manufacturer,
        model,
        fuelType,
        yearOfManufacture,
        mileage,
        engineSize,
        type,
        chassisNumber,
        hexColor
    ) {
        return this.post('/api/v1.0/vehicles', {
            fleetId,
            registrationNumber,
            manufacturer,
            model,
            fuelType,
            yearOfManufacture,
            mileage,
            engineSize,
            type,
            chassisNumber,
            hexColor
        })
    }
    async editVehicle (
        id,
        fleetId,
        registrationNumber,
        manufacturer,
        model,
        fuelType,
        yearOfManufacture,
        mileage,
        engineSize,
        vehicleType,
        chassisNumber,
        hexColor
    ) {
        return this.put('/api/v1.0/vehicles', {
            id,
            fleetId,
            registrationNumber,
            manufacturer,
            model,
            fuelType,
            yearOfManufacture,
            mileage,
            engineSize,
            vehicleType,
            chassisNumber,
            hexColor
        })
    }

    async move (vehicles) {
        return this.post(`/api/v1.0/vehicles/move`, {
            vehicles: vehicles
        })
    }
}
